import type {GetServerSideProps} from 'next';
import type {GetServerSidePropsResult} from 'next/types';
import {
  type GetUserDataForAnalyticsResponseType,
  getUserDataForAnalytics,
} from '../../../core/repositories/usersMeRepository';
import {validateCookie} from '../../../core/usecases/auth/checkOauthTokenExistence';
import {PostInquiryTarekomi} from '../../../features/inquiry/components/InquiryTarekomiPage';
import {withHandler} from '../../../server/token/withHandler';
import {ScriptForGA} from '../../../shared/components/ScriptForGA';
import {NoLeftSidebarLayout} from '../../../shared/components/layouts/NoLeftSidebarLayout';
import type {NextPageWithLayout} from '../../_app';

type Props = {
  userDataForAnalytics?: GetUserDataForAnalyticsResponseType;
};

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withOptionalSession'
>(
  {auth: 'optional'},
  async (context): Promise<GetServerSidePropsResult<Props>> => {
    const {cookies} = context.req;
    const {isValid} = validateCookie(cookies);
    if (!isValid) {
      return {
        props: {},
      };
    }

    const userDataResponse = await getUserDataForAnalytics({cookies});
    if (!userDataResponse.ok) {
      return {
        props: {},
      };
    }

    return {
      props: {
        userDataForAnalytics: userDataResponse.value,
      },
    };
  },
);

const InquiryTarekomiPage: NextPageWithLayout<Props> = ({
  userDataForAnalytics,
}) => {
  return (
    <>
      <PostInquiryTarekomi />
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

export default InquiryTarekomiPage;

InquiryTarekomiPage.getLayout = (page) => (
  <NoLeftSidebarLayout>{page}</NoLeftSidebarLayout>
);
